import blog1 from '../img/blogs/1.jpg';
import blog2 from '../img/blogs/2.JPG';
import blog3 from '../img/blogs/3.JPG';
import blog4 from '../img/blogs/4.JPG';


const blogs = [
    {
        id: 1,
        image: blog1,
        title: 'Hp Tech',
        live: 'Live Site',
        link: 'https://sleepy-panini-86b83d.netlify.app',
        linkgc: 'https://github.com/alihaydararman/hp-laptop-client-site',
        linkgs: 'https://github.com/alihaydararman/hp-laptop-server-side',
        git: 'GitHub(Client)',
        gits: 'GitHub(Server)',
        date: '21',
        month: 'Mar',
        year: '2020',
        details: 'Details',
        projects: '/projects1'
    },
    {
        id: 2,
        image: blog2,
        title: 'Fenian Tourism',
        live: 'Live Site',
        link: 'https://serene-noyce-1e2f7d.netlify.app/',
        linkgc: 'https://github.com/alihaydararman/tourism-website-client-side',
        linkgs: 'https://github.com/alihaydararman/-tourism-website-server-side',
        git: 'GitHub(Client)',
        gits: 'GitHub(Server)',
        date: '09',
        month: 'Dec',
        year: '2019',
        details: 'Details',
        projects: '/projects2'
    },
    {
        id: 3,
        image: blog3,
        live: 'Live Site',
        git: 'GitHub(Client)',
        title: 'Haydar Medical Center',
        link: 'https://affectionate-panini-29c3f2.netlify.app/',
        linkgc: 'https://github.com/alihaydararman/healthcare-related-website',
        date: '15',
        month: 'Jun',
        year: '2018',
        details: 'Details',
        projects: '/projects3'
    },
    {
        id: 4,
        live: 'Live Site',
        image: blog4,
        title: 'Programmer Team BD',
        link: 'https://elastic-haibt-30dce4.netlify.app/',
        date: '04',
        month: 'Aug',
        year: '2020',
        details: 'Details',
        projects: '/projects4'
    },

];

export default blogs;